import { DurationMode } from "PFTypes/booking";
import { Option } from "PFTypes/options";
import { useTranslation } from "react-i18next";

type DurationModeOptionsReturn = {
  durationModeOptions: Option<DurationMode>[];
};

export const useDurationModeOptions = (allowedDurationModes: DurationMode[]): DurationModeOptionsReturn => {
  const { t } = useTranslation();

  const durationModeOptions: Option<DurationMode>[] = [
    {
      id: DurationMode.Days,
      original: DurationMode.Days,
      value: DurationMode.Days,
      displayElement: t("availabilityRequirement.days")
    },
    {
      id: DurationMode.Hours,
      original: DurationMode.Hours,
      value: DurationMode.Hours,
      displayElement: t("availabilityRequirement.hours")
    }
  ].filter(({ id }) => allowedDurationModes.includes(id));

  return { durationModeOptions };
};
